const ramoRoutes = [
  {
    path: '/ramo',
    name: 'ramo',
    component: () =>
      import(/* webpackChunckName: "planilla" */ '../MatenimientoRamo.vue'),
  },
];

export default ramoRoutes;
